/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const legalRegulatoryEnumsIndividualsAffectedOptionEnum = {
    Yes: 'Yes',
    No: 'No',
    Unknown: 'Unknown',
} as const;

export type LegalRegulatoryEnumsIndividualsAffectedOptionEnumKey =
    (typeof legalRegulatoryEnumsIndividualsAffectedOptionEnum)[keyof typeof legalRegulatoryEnumsIndividualsAffectedOptionEnum];

export type LegalRegulatoryEnumsIndividualsAffectedOption = LegalRegulatoryEnumsIndividualsAffectedOptionEnumKey;
